export const boolToReadable = (value: boolean) => (value ? 'Да' : 'Нет');
